import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import RadioGroup from '../../../components/RadioGroup/RadioGroup';
import './FeedbackFormWs.css';

class FeedbackFormWs extends React.PureComponent {
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
        this.state = {
            didMount: false
        };
    }

    async componentDidMount() {
        const workshopId = this.props.match.params.id;
        this.props.updateValue({
            target: { name: 'workshopID', value: workshopId }
        });

        // if (!this.props.talksById[workshopId]) {
        //     await this.props.fetchTalkDetails(workshopId);
        // }

        this.setState({ didMount: true });
    }

    onSubmit = event => {
        event.preventDefault();
        if (this.isValidForm()) {
            this.props.submitFFForm(this.props.talksById[this.props.match.params.id].title);
        }
    };

    closeAlert = () => {
        this.props.updateFormStatus('formFailed', false);
    };

    isValidForm = () => {
        if (
            (this.props.fields.email.value !== '' && this.props.fields.userName.value === '') ||
            (this.props.fields.email.value === '' && this.props.fields.userName.value !== '')
        ) {
            return false;
        }

        if (
            this.props.fields.userName.value !== '' &&
            !/(.+)@(.+){2,}\.(.+){2,}/.test(this.props.fields.email.value)
        ) {
            return false;
        }

        // eslint-disable-next-line
        return Object.keys(this.props.fields).every(key =>
            this.props.fields[key].required ? this.props.fields[key].value : true
        );
    };

    render() {
        const data = this.props.fields;
        const submitFailedMessage = this.props.formFailed ? (
            <div className="notification is-danger alert-submit-failed text-center" role="alert">
                <button
                    aria-label="Close"
                    className="delete"
                    data-dismiss="alert"
                    onClick={this.closeAlert}
                    type="button"
                >
                    <span aria-hidden="true">×</span>
                </button>
                {this.props.message !== ''
                    ? this.props.message
                    : 'Something went wrong and your information was not stored. Please, try again.'}
            </div>
        ) : null;

        const submitSuccessMessage = this.props.formSubmitted ? (
            <div className="notification is-success text-center" role="alert">
                Feedback was successfully submitted, thank you.
            </div>
        ) : null;

        const inProgress = this.props.formSubmitInProgress ? (
            <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
        ) : null;

        const missingFieldsMessage = this.isValidForm() ? null : (
            <h3 className="text-center ff-bottom-request">
                <b className="text-danger ff-request">Please fill in all required fields (*).</b>
            </h3>
        );

        const workshopId = this.props.match.params.id;

        if (this.state.didMount && !this.props.talksById[workshopId]) {
            return (
                <section className="section" id="ff">
                    <div className="page-header text-center ff-form">
                        <h1 className="title">Hands-on Labs Feedback Form</h1>
                    </div>
                    <h4 className="title is-4">Oops ! There is no such workshop.</h4>
                </section>
            );
        }

        if (!this.props.talksById[workshopId]) {
            return null;
        }

        return (
            <section className="section" id="ff">
                <div className="page-header text-center ff-form">
                    <h1 className="title">Hands-on Labs Feedback Form</h1>
                </div>
                {missingFieldsMessage}
                <div className="container feedback-form">
                    <form className="form-horizontal" noValidate onSubmit={this.onSubmit}>
                        <div className="form-group field is-horizontal columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="overall-assessment"
                            >
                                Overall assessment of the hands-on lab{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="overall-assessment">
                                <RadioGroup
                                    dataField={data.overall.value}
                                    name="overall"
                                    updateValue={this.props.updateValue}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="overall-assessment-comment"
                            >
                                Additional comment about overall assessment
                            </label>
                            <div className="column fix-space-sm" name="overall-assessment-comment">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="overallComment"
                                    onChange={this.props.updateValue}
                                    placeholder="Your additional assessment. Maximum 1000 characters."
                                    type="text"
                                    value={data.overallComment.value}
                                />
                            </div>
                        </div>

                        <div className="form-group field is-horizontal columns">
                            <label className="control column is-4 label" htmlFor="hands-on-content">
                                Assessment of hands-on lab content{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="hands-on-content">
                                <RadioGroup
                                    dataField={data.handsOnContent.value}
                                    name="handsOnContent"
                                    updateValue={this.props.updateValue}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="hands-on-content-comment"
                            >
                                Additional comment about hands-on lab content
                            </label>
                            <div className="column fix-space-sm" name="hands-on-content-comment">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="handsOnContentComment"
                                    onChange={this.props.updateValue}
                                    placeholder="Your additional assessment. Maximum 1000 characters."
                                    type="text"
                                    value={data.handsOnContentComment.value}
                                />
                            </div>
                        </div>

                        <div className="form-group field is-horizontal columns">
                            <label className="control column is-4 label" htmlFor="instructor">
                                Assessment of the lecturer/hands-on lab instructor{' '}
                                <strong className="red-font">*</strong>
                            </label>
                            <div className="control field column" name="instructor">
                                <RadioGroup
                                    dataField={data.instructor.value}
                                    name="instructor"
                                    updateValue={this.props.updateValue}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label
                                className="control column is-4 label"
                                htmlFor="instructor-comment"
                            >
                                Additional comment about lecturer/hands-on lab instructor
                            </label>
                            <div className="column fix-space-sm" name="instructor-comment">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="instructorComment"
                                    onChange={this.props.updateValue}
                                    placeholder="Your additional assessment. Maximum 1000 characters."
                                    type="text"
                                    value={data.instructorComment.value}
                                />
                            </div>
                        </div>

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="other">
                                Other comments
                            </label>
                            <div className="column fix-space-sm" name="other">
                                <textarea
                                    className="form-control textarea"
                                    maxLength="1000"
                                    name="otherComments"
                                    onChange={this.props.updateValue}
                                    placeholder="Any other ideas. Maximum 1000 characters."
                                    type="text"
                                    value={data.otherComments.value}
                                />
                            </div>
                        </div>

                        <hr />

                        <div className="form-group columns">
                            <label className="control column is-4 label" htmlFor="email">
                                Submit your feedback anonymously or provide us with your contact
                                details and have a chance to win iPad mini 256GB 2019, Samsung
                                Galaxy Watch, or Apple AirPods 2019 from Accenture in our lottery{' '}
                                <ins>(both fields are required in such case)</ins>
                            </label>
                            <div className="column fix-space-sm">
                                <input
                                    className="control input is-rounded"
                                    name="email"
                                    onChange={this.props.updateValue}
                                    placeholder="Your email"
                                    type="email"
                                    value={data.email.value}
                                />
                            </div>
                            <div className="column fix-space-sm">
                                <input
                                    className="control input is-rounded"
                                    name="userName"
                                    onChange={this.props.updateValue}
                                    placeholder="Your name"
                                    type="text"
                                    value={data.userName.value}
                                />
                            </div>
                        </div>

                        {missingFieldsMessage}
                        {submitSuccessMessage}
                        {submitFailedMessage}
                        {inProgress}

                        <div className="submit">
                            <button
                                className="button is-large is-rounded btn-submit"
                                disabled={
                                    !this.isValidForm() ||
                                    this.props.formSubmitInProgress ||
                                    this.props.formSubmitted
                                }
                                type="submit"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}

FeedbackFormWs.propTypes = {
    // eslint-disable-next-line
    fields: PropTypes.object.isRequired,
    formFailed: PropTypes.bool.isRequired,
    formSubmitInProgress: PropTypes.bool.isRequired,
    formSubmitted: PropTypes.bool.isRequired,
    match: PropTypes.objectOf(PropTypes.any).isRequired,
    message: PropTypes.string.isRequired,
    submitFFForm: PropTypes.func.isRequired,
    talksById: PropTypes.objectOf(PropTypes.object).isRequired,
    updateFormStatus: PropTypes.func.isRequired,
    updateValue: PropTypes.func.isRequired
};

export default withRouter(FeedbackFormWs);
